import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "373",
  "slug": "most-populous-countries-in-the-world-ranked",
  "title": "The Most Populous Countries: A Dated Comparison",
  "excerpt": "Use one population dataset and reference year before comparing national totals.",
  "date": "2026-06-08",
  "category": "Geography",
  "image": "https://images.unsplash.com/photo-1499669404910-ba8b35824a3c?ixid=M3w5NjY4NzN8MHwxfHNlYXJjaHwxfHxjcm93ZGVkJTIwY2l0eSUyMGFlcmlhbHxlbnwxfDB8fHwxNzgwOTA2Mjg2fDA&ixlib=rb-4.1.0&w=800&q=80&fit=crop",
  "readTime": "2 min",
  "author": "EarthGuessr Team",
  "content": [
    {
      "type": "paragraph",
      "text": "India and China lead the United Nations' World Population Prospects 2024 comparison, with roughly 1.45 billion and 1.42 billion people at mid-2024. The United States is third. Those figures describe a dated snapshot, not a live population counter."
    },
    {
      "type": "paragraph",
      "text": "The UN dataset combines demographic evidence with estimates and projections. A census count, an estimate for another year, and a projection should not be mixed into one ranking without explanation."
    },
    {
      "type": "heading",
      "text": "Comparing the larger populations"
    },
    {
      "type": "paragraph",
      "text": "In the 2024 UN comparison, the countries after the first three are Indonesia, Pakistan, Nigeria, Brazil, Bangladesh, Russia, and Ethiopia. Mexico follows that group. Other lists may place Mexico in the top ten because they use different estimates or earlier reference years."
    },
    {
      "type": "paragraph",
      "text": "When updating the list, take every row from the same release and date. Keep projections labelled as projections, including the scenario used. A future ranking is conditional on demographic assumptions."
    },
    {
      "type": "heading",
      "text": "A national total says little about a particular image"
    },
    {
      "type": "paragraph",
      "text": "Large populations are distributed unevenly. A cropped view of farmland in India can look much less built up than a city centre in a country with far fewer people. Russia's large area also contains both concentrated settlements and extensive sparsely settled regions."
    },
    {
      "type": "paragraph",
      "text": "Use roads, building patterns, and land use to describe the area in front of you. Do not infer a country's population from how crowded one image looks. For a useful comparison, locate the main population concentrations on a population-density map, then compare them with relief and water availability."
    }
  ],
  "sources": [
    {
      "title": "UN: World Population Prospects 2024, dataset and methodology",
      "url": "https://population.un.org/wpp/"
    },
    {
      "title": "UN: World Population Prospects 2024 summary",
      "url": "https://www.un.org/development/desa/pd/sites/www.un.org.development.desa.pd/files/undesa_pd_2024_wpp_2024_advance_unedited_0.pdf"
    }
  ]
};
